import { text_colorTextSecondary } from 'ext-ui/style/colors'
import React, { SVGProps } from 'react'

const SvgSidenavExpenseCategoriesInactive = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 18 18"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M6 6H6.0075M3.42206 2.20294L2.20294 3.42206C1.94352 3.68148 1.8138 3.8112 1.72104 3.96257C1.6388 4.09678 1.57819 4.2431 1.54145 4.39615C1.5 4.56878 1.5 4.75223 1.5 5.11911L1.5 7.25589C1.5 7.62277 1.5 7.80622 1.54145 7.97885C1.57819 8.1319 1.6388 8.27822 1.72104 8.41243C1.8138 8.5638 1.94352 8.69351 2.20294 8.95294L7.95441 14.7044C8.84545 15.5955 9.29097 16.041 9.80471 16.2079C10.2566 16.3547 10.7434 16.3547 11.1953 16.2079C11.709 16.041 12.1545 15.5954 13.0456 14.7044L14.7044 13.0456C15.5954 12.1545 16.041 11.709 16.2079 11.1953C16.3547 10.7434 16.3547 10.2566 16.2079 9.80471C16.041 9.29097 15.5954 8.84545 14.7044 7.95441L8.95294 2.20294C8.69351 1.94352 8.5638 1.8138 8.41243 1.72104C8.27822 1.6388 8.1319 1.57819 7.97885 1.54145C7.80622 1.5 7.62277 1.5 7.25589 1.5L5.11911 1.5C4.75223 1.5 4.56878 1.5 4.39615 1.54144C4.2431 1.57819 4.09678 1.6388 3.96257 1.72104C3.8112 1.8138 3.68148 1.94352 3.42206 2.20294ZM6.375 6C6.375 6.20711 6.20711 6.375 6 6.375C5.79289 6.375 5.625 6.20711 5.625 6C5.625 5.79289 5.79289 5.625 6 5.625C6.20711 5.625 6.375 5.79289 6.375 6Z"
      stroke={props.stroke || text_colorTextSecondary}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgSidenavExpenseCategoriesInactive
